export const blockIconsTransportationDirectionsRailwayNew = (
	<span className='material-symbols-outlined'>directions_railway</span>
);
